// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class HolidaysFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    const hierarchy = this.view.state.hierarchy;
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const data = {
      ...this.change,
      ...hierarchy,
    };

    try {
      await this.upsertUseCase.execute(collection, data);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   if (this.object.id) {
  //     this.change.id = this.object.id;
  //   } else {
  //     this.change.acl = this.view.getAcl();
  //   }
  //   try {
  //     const region = this.view.getStateRegion();
  //     // console.warn("OFFICE: ", office);
  //     if (region === undefined) {
  //       throw new Error("Select Region");
  //     }
  //     this.change.region = region;
  //     this.change.status = "active";
  //     // this.showSuccess();
  //     // console.warn("DD: ", this.change);
  //     await this.upsertUseCase.execute(collection, this.change);
  //     this.change = {};
  //   } catch (error) {
  //     throw error; // rethrow the error to be caught by the caller
  //   }
  // }
}

export default HolidaysFormPresenter;
